// Roles y constantes de permisos. Replicado del backend.
// Si en el back se agregan/quitan roles, mantener este archivo sincronizado.

export const ROLES = Object.freeze({
  ADMIN: 'admin',
  COMERCIAL: 'comercial',
  OPERACIONES: 'operaciones',
  FACTURACION: 'facturacion',
  CLIENTE: 'cliente',
});

export const ROLE_VALUES = Object.freeze(Object.values(ROLES));

export const ROLE_OPTIONS = [
  { value: ROLES.ADMIN, label: 'Administrador' },
  { value: ROLES.COMERCIAL, label: 'Comercial' },
  { value: ROLES.OPERACIONES, label: 'Operaciones' },
  { value: ROLES.FACTURACION, label: 'Facturación' },
  { value: ROLES.CLIENTE, label: 'Cliente' },
];

export const ROLE_LABELS = {
  [ROLES.ADMIN]: 'Administrador',
  [ROLES.COMERCIAL]: 'Comercial',
  [ROLES.OPERACIONES]: 'Operaciones',
  [ROLES.FACTURACION]: 'Facturación',
  [ROLES.CLIENTE]: 'Cliente',
};

export const ROLE_BADGES = {
  [ROLES.ADMIN]: 'bg-purple-100 text-purple-800',
  [ROLES.COMERCIAL]: 'bg-blue-100 text-blue-800',
  [ROLES.OPERACIONES]: 'bg-emerald-100 text-emerald-800',
  [ROLES.FACTURACION]: 'bg-amber-100 text-amber-800',
  [ROLES.CLIENTE]: 'bg-slate-100 text-slate-800',
};

export const getRoleLabel = (role) => ROLE_LABELS[role] || role || '—';
export const getRoleBadgeClass = (role) => ROLE_BADGES[role] || 'bg-slate-100 text-slate-800';
